import styled, { css } from 'styled-components';

import { size } from '../layout/helpers';
import { fontRegular } from '../layout/font';

interface WrapperProps {
  $bordered?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  display: flex;
  align-items: stretch;
  background-color: var(--bg-accent, ${(props) => props.theme.color.accent});
  border-radius: 3px;

  ${({ $bordered }) =>
    $bordered &&
    css`
      border: 1px solid ${(props) => props.theme.color.borderAlt};
    `}
`;

export const Input = styled.input.attrs(() => ({
  type: 'text',
}))`
  ${fontRegular};
  flex: 1 1 auto;
  display: block;
  width: 100%;
  height: ${(props) => props.theme.distances.inputHeight};
  padding: 0 ${size(2)};
  background-color: transparent;
  font-size: 16px;
  border: none;
  border-radius: 0;
  box-shadow: none;
  -moz-appearance: none;
  -webkit-appearance: none;

  &::-webkit-input-placeholder {
    font-family: inherit;
    color: var(--text-color-accent, ${(props) => props.theme.color.textDarkLighten});
    font-size: 1em;
  }

  &:-moz-placeholder {
    font-family: inherit;
    color: var(--text-color-accent, ${(props) => props.theme.color.textDarkLighten});
    font-size: 1em;
  }

  &::-moz-placeholder {
    font-family: inherit;
    color: var(--text-color-accent, ${(props) => props.theme.color.textDarkLighten});
    font-size: 1em;
  }

  &:-ms-input-placeholder {
    font-family: inherit;
    color: var(--text-color-accent, ${(props) => props.theme.color.textDarkLighten});
    font-size: 1em;
  }
`;

export const Unit = styled.div`
  flex-shrink: 0;
  padding-right: ${size(2)};
  align-self: center;
  font-size: 16px;
  color: var(--text-color-accent, ${(props) => props.theme.color.textDarkLighten});
`;
